import { DISCOUNTS_BY_AMOUNT } from '../../../config';

export function getDiscountByAmount(amount){
  let discount = 0;
  for (let item in DISCOUNTS_BY_AMOUNT){
    if (amount >= item) {
      if (DISCOUNTS_BY_AMOUNT[item] > discount){
        discount = DISCOUNTS_BY_AMOUNT[item];
      }
    }
  }
  return discount;
}